module.exports = __webpack_public_path__ + "img/transport_med_paavirkningsgrad.28435582.jpg";